/* globals serverParams */
import { guff } from 'bam-node-baseball-savant/utils/guff'

const { is_team_type, target_base } = serverParams
// Match player-update section if changing
const baseHTMLMap = {
    '2B': 'Second Base',
    '3B': 'Third Base',
    'All': 'All Bases',  // eslint-disable-line
}

const secondaryHeadersNormal = [
    {
        name: '',
        colspan: serverParams.splitYears ? 7 : 6,
        headerClass: 'th-name-header',
    },
    {
        name: `At ${baseHTMLMap[target_base]}`,
        colspan: 5,
        headerClass: 'th-title-header',
    },
    {
        name: 'feet/second',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: 'feet',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: 'seconds',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: 'seconds',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: 'mph',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: '',
        colspan: 5,
        headerClass: 'th-name-header',
    },
]
const secondaryHeadersExpanded = [
    {
        name: '',
        colspan: serverParams.splitYears ? 7 : 6,
        headerClass: 'th-name-header',
    },
    {
        name: `At ${target_base === '2B' ? 'Second' : 'Third'} Base`,
        colspan: 5,
        headerClass: 'th-title-header',
    },
    {
        name: 'feet/second',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: 'feet',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: 'seconds',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: 'seconds',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: 'mph',
        colspan: 1,
        headerClass: 'th-secondary-em',
    },
    {
        name: `
            <div style="white-space: normal; font-weight: normal; text-align: left;">
                <strong>What's this?</strong> <em>Each play's Catcher's CS Above Avg can be broken down into credit for different skills. "Teamwork" refers to value that can't be assigned directly to a catcher -- which may imply great tags or missed slides. <a href="http://tangotiger.com/index.php/site/article/statcast-lab-cs-accuracy-model" target="_blank">Learn more.</a>.</em>
            </div>
            <br />
            <div>Catcher's CS Above Average Breakdown</div>`,
        colspan: 6,
        headerClass: 'th-title-header',
    },
]

const headersExpanded = [
    {
        name: 'Throw <br/>Speed',
        field: 'n_xcs_with_flight_over_xcs',
        headerClass:
            'th-component-header align-center th-vertical-bottom border-left',
        fieldClass: 'tr-data border-left',
        type: 'number',
        displayFn: (value) => guff(value, 'n_xcs'),
        toolTip:
            'The number of extra caught stealings attributed to the catcher’s arm strength compared to the expectation of an average catcher.',
    },
    {
        name: 'Exchange',
        field: 'n_xcs_with_exchange_over_xcs',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'n_xcs'),
        toolTip: `The number of extra caught stealings attributed to the catcher’s exchange time compared to the expectation of an average catcher.
            The exchange time is the time between the catcher receiving the pitch and releasing his throw.`,
    },
    {
        name: 'Accuracy',
        field: 'n_xcs_with_accuracy_over_xcs',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'n_xcs'),
        toolTip:
            'The number of extra caught stealings attributed to the catcher’s accuracy compared to the expectation of an average catcher.',
    },
    {
        name: 'Teamwork: <br/> Bounced <br/> Throws',
        field: 'n_xcs_with_ground_other_over_xcs',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'n_xcs'),
        toolTip:
            'The number of extra caught stealings on bounced throws which cannot be attributed to the catcher’s arm strength, exchange time, or accuracy compared to the expectation of an average catcher.',
    },
    {
        name: 'Teamwork: <br/> On Fly <br/> Throws',
        field: 'n_xcs_with_onfly_other_over_xcs',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'n_xcs'),
        toolTip:
            'The number of extra caught stealings on throws in the air which cannot be attributed to the catcher’s arm strength, exchange time, or accuracy compared to the expectation of an average catcher.',
    },
    {
        name: 'Not <br/> Tracked',
        field: 'n_xcs_with_untracked_other_over_xcs',
        headerClass:
            'th-component-header align-center th-vertical-bottom border-right',
        fieldClass: 'tr-data border-right',
        type: 'number',
        displayFn: (value) => guff(value, 'n_xcs'),
        toolTip:
            'The number of extra caught stealings (compared to an average catcher) on stolen base attempts in which we were unable to track the catcher’s throw.',
    },
    // {
    //     name: 'Other',
    //     field: 'n_xcs_with_other_over_xcs',
    //     headerClass:
    //         'th-component-header align-center th-vertical-bottom border-right',
    //     fieldClass: 'tr-data border-right',
    //     type: 'number',
    //     displayFn: (value) => (value ? Math.round(Number(value)) : '--'),
    //     toolTip:
    //         'The number of extra caught stealings that cannot be attributed to the catcher’s arm strength, exchange time, or accuracy compared to the expectation of an average catcher.',
    // },
]
const headersNormal = [
    {
        name: is_team_type ? 'Team' : 'Player',
        field: 'entity_name',
        customSortField: 'entity_name',
        headerClass: `th-component-header align-left th-vertical-bottom table-static-column`,
        fieldClass: `tr-data align-left table-static-column`,
        photo: is_team_type
            ? undefined
            : '<img class="player-mug" onError="this.onerror=null;this.src=\'https://content.mlb.com/images/headshots/current/60x60/generic.png\';" src="https://content.mlb.com/images/headshots/current/60x60/{1}.png">',
        photoId: 'entity_id',
        defaultSortDir: 'asc',
        displayFn: (entity_name, d) =>
            is_team_type
                ? entity_name
                : `<a href="/savant-player/${d.entity_id}">${entity_name}</a>`, // what levels of unsafe is this?
    },
    {
        name: is_team_type ? '' : 'Team',
        field: is_team_type ? 'entity_name' : 'team_name',
        headerClass: `th-component-header`,
        fieldClass: `tr-data`,
        photo: '<img class="table-team-logo" src="{1}" onerror="this.onerror=\'\';this.src=\'/site-core/images/savant-mlb.svg\'" />',
        photoId: 'team_image_url',
        defaultSortDir: 'asc',
        photoOnly: true,
    },
    {
        name: 'Year',
        field: 'start_year',
        headerClass: `th-component-header align-center th-vertical-bottom ${
            serverParams.splitYears ? '' : ' hide'
        }`,
        fieldClass: `tr-data ${serverParams.splitYears ? '' : ' hide'}`,
    },
    {
        name: `SB Att.<br/> (${target_base})`,
        field: 'n',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => (value ? value.toLocaleString() : '--'),
        toolTip: 'Number of steal attempts',
    },
    {
        name: 'Catcher <br/>Stealing <br/> Runs',
        field: 'cs_raa',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'cs_raa'),
        toolTip: `Translation of Catcher Stealing Above Average to a run value.`,
    },
    {
        name: "Catcher's <br/> CS Above <br/> Average",
        field: 'n_cs_aa',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'n_cs_aa'),
        highlightDynamic: true,
        toolTip:
            'The number of extra caught stealings compared to the expectation of an average catcher. Calculated by Caught Stealing - Lg. Avg. CS',
    },
    {
        name: 'CS',
        field: 'n_cs',
        headerClass:
            'th-component-header align-center th-vertical-bottom border-left',
        fieldClass: 'tr-data border-left',
        type: 'number',
    },
    {
        name: 'CS%',
        field: 'rate_cs',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'rate_cs'),
        toolTip: `The percentage of steal attempts that were caught stealing. Calculated by to Caught Stealing / Throw Opportunities.`,
    },
    {
        name: 'Est. <br/> CS',
        field: 'n_xcs',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'n_xcs'),
        toolTip:
            'The number of caught stealing expected based on a league average catcher',
    },
    {
        name: 'Est. <br/> CS%',
        field: 'rate_xcs',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'rate_xcs'),
        toolTip: `The CS% expected based on a league average catcher. Calculated by Lg. Avg. CS / Throw Opportunities.`,
    },
    {
        name: 'CS Above <br/> Avg. <br/>/ Throw',
        field: 'rate_cs_aa',
        headerClass:
            'th-component-header align-center th-vertical-bottom border-right',
        fieldClass: 'tr-data border-right',
        type: 'number',
        displayFn: (value) => guff(value, 'rate_cs_aa'),
        toolTip: `The CS Above Avg. gained per throw compared to the expectation of an average catcher. Calculated by CS Above Avg. / Throw Opportunities.`,
    },
    {
        name: 'Runner <br/>Speed',
        field: 'seasonal_sprint_speed',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'seasonal_sprint_speed'),
        toolTip: `The average sprint speed of the runners attempting to steal.`,
    },
    {
        name: `Runner <br/>Distance <br/>from ${
            target_base === '2B' ? '2nd' : '3rd'
        }`,
        field: 'distance_to_target',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'distance_to_target'),
        toolTip: `The average distance the runner was from second base when the pitch crossed the plate.`,
    },

    {
        name: 'Pop <br/>Time',
        field: 'pop_time',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'pop_time'),
        toolTip: `The time it takes from catcher receiving the pitch to the middle infielder catching the throw at second.`,
    },
    {
        name: 'Exchange <br/> Time',
        field: 'exchange_time',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'exchange_time'),
        toolTip: `The average of exchange times in seconds. Exchange is the time between the catcher receiving the pitch and releasing his throw.`,
    },
    {
        name: 'Arm <br />Strength',
        field: 'arm_strength',
        headerClass: 'th-component-header align-center th-vertical-bottom',
        fieldClass: 'tr-data',
        type: 'number',
        displayFn: (value) => guff(value, 'arm_strength'),
        toolTip: `The average arm strength of the catcher's throws to second.`,
    },
]
const videoColumn = {
    name: '',
    field: '',
    headerClass:
        'th-component-header align-center th-vertical-bottom cursor-initial',
    fieldClass: 'tr-data',
    sortable: false,
    displayFn: () =>
        `
            <span data-video-icon style="inline-block; padding: 2px; border-radius: 50%; border: 2px solid #c2c2c2;">
                <img src="/site-core/images/video.png" style="width: 18px; cursor: pointer;">
            </span>
            `,
}

export const headers = {
    normal: [...headersNormal, videoColumn],
    expanded: [...headersNormal, ...headersExpanded, videoColumn],
}

export const secondaryHeaders = {
    normal: secondaryHeadersNormal,
    expanded: secondaryHeadersExpanded,
}
